<template>
  <div>
    <Header @save="handleSaveClick" @confirm="handleConfirmClick" />
    <div :style="{ height: screenHeight + 'px' }">

      <component-tabs :style="style.componentTabs" @update:drag="handledrag" :drag="drag" :components="components" @click="handleTabClick"></component-tabs>

      <phone-box :style="style.phoneBox" :footer="components.footer" :designs="designs" :editing="editing"
        @click="handleDesignClick" @delete-item="handleDeleteItem" @designs-changed="handleUploadArr" :drag="drag"></phone-box>

      <setting-box :style="style.settingBox" :editing="editing"></setting-box>

    </div>
  </div>
</template>

<script>
import Header from '../components/Header'
import ComponentTabs from '../components/ComponentTabs'
import PhoneBox from '../components/PhoneBox'
import SettingBox from '../components/SettingBox'
import TitlePreview from '../components/title/TitlePreview'
import TitleSetting from '../components/title/TitleSetting'
import TextPreview from '../components/text/TextPreview'
import TextSetting from '../components/text/TextSetting'
import WhitePreview from '../components/white/WhitePreview'
import WhiteSetting from '../components/white/WhiteSetting'
import CompanyInfoPreview from '../components/companyInfo/CompanyInfoPreview'
import CompanyInfoSetting from '../components/companyInfo/CompanyInfoSetting'
import CompanyConsultPreview from '../components/companyConsult/CompanyConsultPreview'
import CompanyConsultSetting from '../components/companyConsult/CompanyConsultSetting'
import PhonePreview from '../components/phone/PhonePreview'
import PhoneSetting from '../components/phone/PhoneSetting'
import ImagePreview from '../components/image/ImagePreview'
import ImageSetting from '../components/image/ImageSetting'
import ManageTeamPreview from '../components/manageTeam/ManageTeamPreview'
import ManageTeamSetting from '../components/manageTeam/ManageTeamSetting'
import CompanyPartnerPreview from '../components/companyPartner/CompanyPartnerPreview'
import CompanyPartnerSetting from '../components/companyPartner/CompanyPartnerSetting'
import AddressPreview from '../components/address/AddressPreview'
import AddressSetting from '../components/address/AddressSetting'
import ContactMePreview from '../components/contactMe/ContactMePreview'
import ContactMeSetting from '../components/contactMe/ContactMeSetting'
import carpuseView from '../components/carousel/carouselView'
import carouselSetting from '../components/carousel/carouselSetting'
import videoPreview from '../components/video/videoPreview'
import imgTextPreview from '../components/imgText/imgTextPreview'
import imgTextSetting from '../components/imgText/imgTextSetting'
import articleView from '../components/article/articleView'
import articleSetting from '../components/article/articleSetting'
import seachView from '../components/seach/seachPreview'
import seachSetting from '../components/seach/seachSetting'
import formView from '../components/form/formPreview'
import formSetting from '../components/form/formSetting'
import wenzView from '../components/wenz/wenzPreview'
import wenzSetting from '../components/wenz/wenzSetting'
import gonggaoView from '../components/gonggao/gonggaoPreview'
import gonggaoSetting from '../components/gonggao/gonggaoSetting'
import videoSetting from '../components/video/videoSetting'
import articleListView from '../components/article/articleListView'
import articleListSetting from '../components/article/articleListSetting'
import articleDeitelView from '../components/article/articleDeitelView'
import articleDeitelSetting from '../components/article/articleDeitelSetting'
import productDetailsView from '../components/article/productDetailsView'
import productDetailSetting from '../components/article/productDetailSetting'
import footToolbarSetting from '../components/footToolbarSetting'
import chanpinView from '../components/chanpin/chanpinView.vue'
import chanpinSetting from '../components/chanpin/chahnpinSetting.vue'

import home from '../assets/footer/home.png'
import infohome from '../assets/footer/infoHome.png'
import chanpin from '../assets/footer/chanpin.png'
import xinwen from '../assets/footer/xinwen.png'
import about from '../assets/footer/about.png'
import lianxi from '../assets/footer/lianxi.png'

import api from '../api/index'

export default {
  name: 'ColEditWindow',
  components: {
    Header,
    ComponentTabs,
    PhoneBox,
    SettingBox,
    footToolbarSetting
  },
  data: function () {
    return {
      // 屏幕尺寸
      screenHeight: 0,
      screenWidth: 0,
      drag: false,
      pageLink: [
        {
          title: '首页',
          page: 'index'
        },
        {
          title: '产品',
          page: 'product'
        },
        {
          title: '留言',
          page: 'message'
        },
        {
          title: '案例',
          page: 'case'
        },
        {
          title: '新闻',
          page: 'news'
        },
        {
          title: '联系',
          page: 'contact'
        }
      ],
      components: {
        // 模块组件数据
        modules: [
          {
            name: '网页',
            index: '1',
            children: [
              {
                name: '首页',
                icon: '',
                type: 1,
                typeName: 'modules',
                setting: {
                  title: '',
                  component: ''
                },
                data: {}
              },
              {
                name: '在线留言',
                icon: 'font-icon font-icon-20',
                type: 2,
                typeName: 'modules',
                preview: formView,
                setting: {
                  title: '表单',
                  component: formSetting
                },
                data: {
                  name: '在线留言',
                  form: {
                    titleValue: true,
                    inputStyle: '描边',
                    mbColor: '#D9DCE2',
                    tcColor: '#ffffff',
                    btnColor: '#409EFF',
                    name: {
                      title: '姓名',
                      tipTxt: '提示文字',
                      errTxt: '请输入姓名'
                    },
                    phone: {
                      title: '电话',
                      tipTxt: '提示文字',
                      errTxt: '请输入手机号',
                      yzErr: '请输入正确手机号'
                    },
                    content: [
                      {
                        type: '1',
                        title: '内容',
                        tipTxt: '请输入您的留言内容',
                        visible: false,
                        errTxt: '此项必填',
                        radioVal: 1,
                        selectVal: '',
                        checkboxGroup: [],
                        emailErr: '邮箱格式不正确',
                        groups: [
                          {
                            text: '选项一',
                            value: 1,
                            checkd: false
                          },
                          {
                            text: '选项二',
                            value: 2,
                            checkd: false
                          },
                          {
                            text: '选项三',
                            value: 3,
                            checkd: false
                          }
                        ],
                        radioMap: [
                          {
                            text: '选项一',
                            value: 1,
                            checkd: false
                          },
                          {
                            text: '选项二',
                            value: 2,
                            checkd: false
                          },
                          {
                            text: '选项三',
                            value: 3,
                            checkd: false
                          }
                        ],
                        selectOptions: [
                          {
                            value: 1,
                            text: '选项一',
                            checkd: false
                          },
                          {
                            value: 2,
                            text: '选项二',
                            checkd: false
                          },
                          {
                            value: 3,
                            text: '选项三',
                            checkd: false
                          }
                        ]
                      }
                    ],
                    btnName: '提交'
                  },
                  infoItme: {
                    bjColor: '#ffffff',
                    yeBj: '15px',
                    sBj: '15px',
                    xBj: '15px'
                  }
                }
              },
              {
                name: '产品',
                icon: 'font-icon font-icon-18',
                type: 3,
                typeName: 'modules',
                preview: chanpinView,
                setting: {
                  title: '产品',
                  component: chanpinSetting
                },
                data: {
                  name: '产品',
                  title: '产品',
                  classification: '无',
                  neiRadio: '2',
                  biliRadio: '1:1',
                  bianjiaoRadio: '直角',
                  boldRadio: '无',
                  duiqiRadio: '居中',
                  conValue: '3',
                  fenlei: '1',
                  consetting: {
                    laiYvalue: '1',
                    shuRadio: '1',

                    fenleiValue: '',
                    restaurants: [],
                    num: 4
                  },
                  productList: [
                    {
                      src: '',
                      name: 'XE205GH 中型挖掘机'
                    },
                    {
                      src: '',
                      name: 'XE205GH 中型挖掘机'
                    },
                    {
                      src: '',
                      name: 'XE205GH 中型挖掘机'
                    },
                    {
                      src: '',
                      name: 'XE205GH 中型挖掘机'
                    }
                  ],
                  infoItme: {
                    bjColor: '#ffffff',
                    yeBj: '15px',
                    sBj: '15px',
                    xBj: '15px'
                  }
                }
              },
              {
                name: '产品详情',
                icon: 'font-icon font-icon-18',
                type: 4,
                typeName: 'modules',
                preview: productDetailsView,
                setting: {
                  title: '产品详情',
                  component: productDetailSetting
                },
                data: {
                  name: '产品详情',
                  title: '产品详情',
                  zhaiyao: true,
                  lianxi: true,
                  phoneInput: '',
                  color1: '#c00401',
                  productList: [
                    {
                      src: '',
                      name: 'XE205GH 中型挖掘机'
                    },
                    {
                      src: '',
                      name: 'XE205GH 中型挖掘机'
                    },
                    {
                      src: '',
                      name: 'XE205GH 中型挖掘机'
                    },
                    {
                      src: '',
                      name: 'XE205GH 中型挖掘机'
                    }
                  ],
                  infoItme: {
                    bjColor: '#ffffff',
                    yeBj: '15px',
                    sBj: '15px',
                    xBj: '15px'
                  }
                }
              }
            ]
          },
          {
            name: '文章',
            index: '2',
            type: 5,
            children: [
              {
                name: '案例',
                icon: '',
                type: 6,
                typeName: 'modules',
                setting: {
                  title: '',
                  component: ''
                },
                data: {
                  name: '案例',
                  list: [
                    {
                      title: '案例',
                      icon: 'el-icon-tickets',
                      obj: {
                        listInfo: {
                          name: '列表',
                          typeName: 'modules',
                          type: 7,
                          preview: articleListView,
                          setting: {
                            title: '文章内页列表',
                            component: articleListSetting
                          },
                          data: {
                            neiRadio: '1',
                            name: '列表',
                            biliRadio: '1:1',
                            bianjiaoRadio: '直角',
                            boldRadio: '无',
                            duiqiRadio: '居中',
                            conValue: '1',
                            infoItme: {
                              bjColor: '#ffffff',
                              yeBj: '15px',
                              sBj: '15px',
                              xBj: '15px'
                            }
                          }
                        },
                        details: {
                          name: '详情',
                          typeName: 'modules',
                          type: 8,
                          preview: articleDeitelView,
                          setting: {
                            title: '内容详情',
                            component: articleDeitelSetting
                          },
                          data: {
                            name: '详情',
                            imgValue: true,
                            browseValue: true
                          }
                        }
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            name: '自定义页面',
            index: '3',
            type: 9,
            children: [
              {
                name: '联系',
                icon: '',
                type: 10,
                typeName: 'modules',
                setting: {
                  title: '',
                  component: ''
                },
                data: {}
              },
              {
                name: '关于',
                icon: '',
                type: 11,
                typeName: 'modules',
                setting: {
                  title: '',
                  component: ''
                },
                data: {}
              }
            ]
          }
        ],
        // 基本组件数据
        basics: [
          {
            name: '企业简介',
            icon: 'font-icon font-icon-1',
            type: 1,
            preview: CompanyInfoPreview,
            setting: {
              title: '企业简介',
              component: CompanyInfoSetting
            },
            data: {
              name: '企业简介',
              title: '企业简介',
              content: '请填写公司简介...'
            }
          },
          {
            name: '轮播',
            icon: 'font-icon font-icon-14',
            type: 2,
            preview: carpuseView,
            setting: {
              title: '轮播',
              component: carouselSetting
            },
            data: {
              name: '轮播',
              title: '轮播',
              carouselImage: [
                { src: '', title: '标题1', link: '首页' },
                { src: '', title: '标题2', link: '产品' }
              ],
              linkList: [
                {
                  title: '首页',
                  page: 'index'
                },
                {
                  title: '产品',
                  page: 'product'
                },
                {
                  title: '留言',
                  page: 'message'
                },
                {
                  title: '案例',
                  page: 'case'
                },
                {
                  title: '新闻',
                  page: 'news'
                },
                {
                  title: '联系',
                  page: 'contact'
                }
              ],
              infoItme: {
                bjColor: '#ffffff',
                yeBj: '0px',
                sBj: '0px',
                xBj: '0px'
              }
            }
          },
          // {
          //   name: '企业咨询',
          //   icon: 'font-icon font-icon-2',
          //   type: 3,
          //   preview: CompanyConsultPreview,
          //   setting: {
          //     title: '企业咨询',
          //     component: CompanyConsultSetting
          //   },
          //   data: {
          //     name: '企业咨询',
          //     title: '企业咨询',
          //     consultList: [
          //       {
          //         title: '咨询标题1',
          //         headImg: '',
          //         time: '2018-01-01',
          //         content: '咨询内容1',
          //         online: true
          //       },
          //       {
          //         title: '咨询标题2',
          //         headImg: '',
          //         time: '2018-01-01',
          //         content: '咨询内容2',
          //         online: true
          //       },
          //       {
          //         title: '咨询标题3',
          //         headImg: '',
          //         time: '2018-01-01',
          //         content: '咨询内容3',
          //         online: false
          //       }
          //     ]
          //   }
          // },
          {
            name: '管理团队',
            icon: 'font-icon font-icon-3',
            type: 4,
            preview: ManageTeamPreview,
            setting: {
              title: '管理团队',
              component: ManageTeamSetting
            },
            data: {
              name: '管理团队',
              title: '管理团队',
              manageList: [
                {
                  avatar: '',
                  name: '张三',
                  job: '高级Java工程师',
                  description: '职位简介...'
                },
                {
                  avatar: '',
                  name: '姓名2',
                  job: '职位2',
                  description: '简介2'
                }
              ]
            }
          },
          {
            name: '合作伙伴',
            icon: 'font-icon font-icon-4',
            type: 5,
            preview: CompanyPartnerPreview,
            setting: {
              title: '合作伙伴',
              component: CompanyPartnerSetting
            },
            data: {
              name: '合作伙伴',
              title: '合作伙伴',
              imageList: [
                {
                  src: ''
                },
                {
                  src: ''
                },
                {
                  src: ''
                }
              ]
            }
          },
          {
            name: '电话',
            icon: 'font-icon font-icon-5',
            type: 6,
            preview: PhonePreview,
            setting: {
              title: '电话设置',
              component: PhoneSetting
            },
            data: {
              name: '电话',
              title: '公司电话',
              phone: '0795-XXXXXXXXX'
            }
          },
          {
            name: '地址',
            icon: 'font-icon font-icon-6',
            type: 7,
            preview: AddressPreview,
            setting: {
              title: '公司地址',
              component: AddressSetting
            },
            data: {
              name: '地址',
              title: '富邦大厦-西门',
              addressDetail: '富邦大厦',
              items: {
                id: '7600048542285331526',
                title: '富邦大厦-西门',
                address: '河北省石家庄市长安区建设北大街',
                category: '室内及附属设施:通行设施类:门/出入口',
                type: 0,
                location: {
                  lat: 38.0451,
                  lng: 114.512096
                },
                adcode: 130102,
                province: '河北省',
                city: '石家庄市',
                district: '长安区'
              }
            }
          },
          {
            name: '联系我们',
            icon: 'font-icon font-icon-7',
            type: 8,
            preview: ContactMePreview,
            setting: {
              title: '联系我们',
              component: ContactMeSetting
            },
            data: {
              name: '联系我们',
              title: '联系我们'
            }
          },
          // {
          //   name: "企业招聘(无)",
          //   icon: "font-icon font-icon-8",
          //   type: 9,
          //   preview: 1,
          //   setting: 2,
          //   data: {}
          // },
          {
            name: '标题',
            icon: 'font-icon font-icon-11',
            type: 9,
            preview: TitlePreview,
            setting: {
              title: '标题栏设置',
              component: TitleSetting
            },
            data: {
              name: '标题',
              title: '标题栏',
              infoItme: {
                bjColor: '#ffffff',
                yeBj: '15px',
                sBj: '15px',
                xBj: '15px'
              },
              conStyle: {
                titleColor: '#000000',
                titleSize: '14',
                titleBold: '否',
                titleAlign: '居左',
                moreType: '无',
                moreText: '查看更多',
                moreColor: '#000000',
                moreImg: '',
                moreLink: '首页'
              },
              link: '请选择标题链接',
              linkList: [
                {
                  title: '首页',
                  page: 'index'
                },
                {
                  title: '产品',
                  page: 'product'
                },
                {
                  title: '留言',
                  page: 'message'
                },
                {
                  title: '案例',
                  page: 'case'
                },
                {
                  title: '新闻',
                  page: 'news'
                },
                {
                  title: '联系',
                  page: 'contact'
                }
              ]
            }
          },
          {
            name: '文本',
            icon: 'font-icon font-icon-12',
            type: 10,
            title: '文本',
            preview: TextPreview,
            setting: {
              title: '文本设置',
              component: TextSetting
            },
            data: {
              name: '文本',
              text: '请输入内容'
            }
          },
          {
            name: '图片',
            icon: 'font-icon font-icon-13',
            type: 11,
            preview: ImagePreview,
            setting: {
              title: '图片设置',
              component: ImageSetting
            },
            data: {
              name: '图片',
              imageType: 1,
              images: '',
              link: '图片导航链接',
              linkList: [
                {
                  title: '首页',
                  page: 'index'
                },
                {
                  title: '产品',
                  page: 'product'
                },
                {
                  title: '留言',
                  page: 'message'
                },
                {
                  title: '案例',
                  page: 'case'
                },
                {
                  title: '新闻',
                  page: 'news'
                },
                {
                  title: '联系',
                  page: 'contact'
                }
              ]
            }
          },
          {
            name: '视频',
            icon: 'font-icon font-icon-15',
            type: 13,
            preview: videoPreview,
            setting: {
              title: '视频',
              component: videoSetting
            },
            data: {
              name: '视频',
              videoVis: '本地',
              playValue: false,
              fengValue: false,
              video: {},
              infoImg: {},
              infoItme: {
                bjColor: '#ffffff',
                yeBj: '0px',
                sBj: '0px',
                xBj: '0px'
              }
            }
          },
          {
            name: '图文导航',
            icon: 'font-icon font-icon-16',
            type: 14,
            preview: imgTextPreview,
            setting: {
              title: '图文设置',
              component: imgTextSetting
            },
            data: {
              name: '图文导航',
              title: '图文',
              imgTextList: [
                {
                  src: '',
                  name: '图文导航',
                  link: '图文导航'
                },
                {
                  src: '',
                  name: '图文导航',
                  link: '图文导航'
                },
                {
                  src: '',
                  name: '图文导航',
                  link: '图文导航'
                }
              ],
              linkList: [
                {
                  title: '首页',
                  page: 'index'
                },
                {
                  title: '产品',
                  page: 'product'
                },
                {
                  title: '留言',
                  page: 'message'
                },
                {
                  title: '案例',
                  page: 'case'
                },
                {
                  title: '新闻',
                  page: 'news'
                },
                {
                  title: '联系',
                  page: 'contact'
                }
              ],
              infoItme: {
                bjColor: '#ffffff',
                yeBj: '15px',
                sBj: '15px',
                xBj: '15px'
              },
              conStyle: {
                tupianjg: '默认',
                space: 10,
                titleSize: '12',
                titleColor: '#000000'
              }
            }
          },
          {
            name: '占位符',
            icon: 'font-icon font-icon-17',
            type: 15,
            preview: WhitePreview,
            setting: {
              title: '占位符设置',
              component: WhiteSetting
            },
            data: {
              name: '占位符',
              height: 10
            }
          },
          {
            name: '产品列表',
            icon: 'font-icon font-icon-18',
            type: 16,
            preview: articleView,
            setting: {
              title: '产品列表',
              component: articleSetting
            },
            data: {
              name: '产品列表',
              title: '产品列表',
              neiRadio: '2',
              biliRadio: '1:1',
              bianjiaoRadio: '直角',
              boldRadio: '无',
              duiqiRadio: '居中',
              conValue: '3',
              consetting: {
                laiYvalue: '1',
                shuRadio: '1',

                fenleiValue: '',
                restaurants: [],
                num: 4
              },
              productList: [
                {
                  src: '',
                  name: 'XE205GH 中型挖掘机'
                },
                {
                  src: '',
                  name: 'XE205GH 中型挖掘机'
                },
                {
                  src: '',
                  name: 'XE205GH 中型挖掘机'
                },
                {
                  src: '',
                  name: 'XE205GH 中型挖掘机'
                }
              ],
              infoItme: {
                bjColor: '#ffffff',
                yeBj: '15px',
                sBj: '15px',
                xBj: '15px'
              }
            }
          },
          {
            name: '文章列表',
            icon: 'font-icon font-icon-19',
            type: 17,
            preview: wenzView,
            setting: {
              title: '文章列表',
              component: wenzSetting
            },
            data: {
              name: '文章列表',
              title: '文章列表',
              neiRadio: '1',
              biliRadio: '1:1',
              bianjiaoRadio: '直角',
              boldRadio: '无',
              conValue: '3',
              productList: [
                {
                  src: '',
                  name: '蓝色“巨无霸”上路！助力孟加拉电网转型升级'
                },
                {
                  src: '',
                  name: '蓝色“巨无霸”上路！助力孟加拉电网转型升级'
                },
                {
                  src: '',
                  name: '蓝色“巨无霸”上路！助力孟加拉电网转型升级'
                },
                {
                  src: '',
                  name: '蓝色“巨无霸”上路！助力孟加拉电网转型升级'
                }
              ],
              infoItme: {
                bjColor: '#ffffff',
                yeBj: '15px',
                sBj: '15px',
                xBj: '15px'
              }
            }
          },
          {
            name: '表单',
            icon: 'font-icon font-icon-20',
            type: 18,
            preview: formView,
            setting: {
              title: '表单',
              component: formSetting
            },
            data: {
              name: '表单',
              form: {
                titleValue: true,
                inputStyle: '描边',
                mbColor: '#D9DCE2',
                tcColor: '#ffffff',
                btnColor: '#409EFF',
                name: {
                  title: '姓名',
                  tipTxt: '提示文字',
                  errTxt: '请输入姓名'
                },
                phone: {
                  title: '电话',
                  tipTxt: '提示文字',
                  errTxt: '请输入手机号',
                  yzErr: '请输入正确手机号'
                },
                content: [
                  {
                    type: '1',
                    title: '内容',
                    tipTxt: '请输入您的留言内容',
                    visible: false,
                    errTxt: '此项必填',
                    radioVal: 1,
                    selectVal: '',
                    checkboxGroup: [],
                    emailErr: '邮箱格式不正确',
                    groups: [
                      {
                        text: '选项一',
                        value: 1,
                        checkd: false
                      },
                      {
                        text: '选项二',
                        value: 2,
                        checkd: false
                      },
                      {
                        text: '选项三',
                        value: 3,
                        checkd: false
                      }
                    ],
                    radioMap: [
                      {
                        text: '选项一',
                        value: 1,
                        checkd: false
                      },
                      {
                        text: '选项二',
                        value: 2,
                        checkd: false
                      },
                      {
                        text: '选项三',
                        value: 3,
                        checkd: false
                      }
                    ],
                    selectOptions: [
                      {
                        value: 1,
                        text: '选项一',
                        checkd: false
                      },
                      {
                        value: 2,
                        text: '选项二',
                        checkd: false
                      },
                      {
                        value: 3,
                        text: '选项三',
                        checkd: false
                      }
                    ]
                  }
                ],
                btnName: '提交'
              },
              infoItme: {
                bjColor: '#ffffff',
                yeBj: '15px',
                sBj: '15px',
                xBj: '15px'
              }
            }
          },
          {
            name: '公告',
            icon: 'font-icon font-icon-21',
            type: 19,
            preview: gonggaoView,
            setting: {
              title: '公告',
              component: gonggaoSetting
            },
            data: {
              name: '公告',
              font: 'font-icon-gg1',
              color: '#931212',
              align: '向上',
              swiper: {
                list: [
                  {
                    title: '欢迎来到我们的网站！',
                    icon: 'font-icon-gg1',
                    link: '请输入链接'
                  },
                  {
                    title: '这里有精彩内容等您探索。',
                    icon: 'font-icon-gg1',
                    link: '请输入链接'
                  },
                  {
                    title: '不要错过最新的活动哦！',
                    icon: 'font-icon-gg1',
                    link: '请输入链接'
                  }
                ]
              },
              linkList: [
                {
                  title: '首页',
                  page: 'index'
                },
                {
                  title: '产品',
                  page: 'product'
                },
                {
                  title: '留言',
                  page: 'message'
                },
                {
                  title: '案例',
                  page: 'case'
                },
                {
                  title: '新闻',
                  page: 'news'
                },
                {
                  title: '联系',
                  page: 'contact'
                }
              ],
              infoItme: {
                bjColor: '#FFF8E9',
                yeBj: '15px',
                sBj: '0px',
                xBj: '0px'
              }
            }
          },
          // {
          //   name: "名片",
          //   icon: "font-icon font-icon-22",
          //   type: 20,
          //   preview: WhitePreview,
          //   setting: {
          //     title: "名片",
          //     component: WhiteSetting
          //   },
          //   data: {
          //     height: 10
          //   }
          // },
          {
            name: '搜索',
            icon: 'font-icon font-icon-23',
            type: 21,
            title: '搜索',
            preview: seachView,
            setting: {
              title: '搜索',
              component: seachSetting
            },
            data: {
              name: '搜索',
              text: '请输入内容',
              styleValue: '描边',
              miaoColor: '#DCDFE6',
              tianColor: '#DCDFE6',
              bacColor: '',
              jiaoValue: '直角',
              alignValue: '居左',
              infoItme: {
                bjColor: '#ffffff',
                yeBj: '15px',
                sBj: '15px',
                xBj: '15px'
              }
            }
          }
        ],
        footer: {
          name: '底部栏',
          icon: '',
          type: 1,
          typeName: 'modules',
          setting: {
            title: '底部栏设置',
            component: footToolbarSetting
          },
          data: {
            title: '底部栏',
            textColor: '#313C68',
            xzColor: '#3A61FF',
            bjColor: '#FFFFFF',
            footerList: [
              {
                src: infohome,
                title: '首页',
                link: 'index',
                active: home
              },
              {
                src: chanpin,
                title: '产品',
                link: 'product',
                active: chanpin
              },
              {
                src: xinwen,
                title: '新闻',
                link: 'news',
                active: xinwen
              },
              {
                src: about,
                title: '关于',
                link: 'about',
                active: about
              },
              {
                src: lianxi,
                title: '联系',
                link: 'contact',
                active: lianxi
              }
            ],
            linkList: [
              {
                title: '首页',
                page: 'index'
              },
              {
                title: '产品',
                page: 'product'
              },
              {
                title: '留言',
                page: 'message'
              },
              {
                title: '案例',
                page: 'case'
              },
              {
                title: '新闻',
                page: 'news'
              },
              {
                title: '联系',
                page: 'contact'
              }
            ]
          }
        }
      },
      // 用户正在编辑的网站数据
      designs: [
        {
          name: '轮播',
          icon: 'font-icon font-icon-14',
          type: 2,
          preview: carpuseView,
          setting: {
            title: '轮播',
            component: carouselSetting
          },
          data: {
            name: '轮播',
            title: '轮播',
            carouselImage: [
              { src: 'http://www-x-it98-x-net.img.addlink.cn/data/images/case/thumb_20200530100511_684.jpg', title: '标题1', link: '首页', page: 'index' },
              { src: 'http://www-x-it98-x-net.img.addlink.cn/data/images/case/thumb_20180923171037_891.jpg', title: '标题2', link: '产品', page: 'product' }
            ],
            linkList: [
              {
                title: '首页',
                page: 'index'
              },
              {
                title: '产品',
                page: 'product'
              },
              {
                title: '留言',
                page: 'message'
              },
              {
                title: '案例',
                page: 'case'
              },
              {
                title: '新闻',
                page: 'news'
              },
              {
                title: '联系',
                page: 'contact'
              }
            ],
            infoItme: {
              bjColor: '#ffffff',
              yeBj: '0px',
              sBj: '0px',
              xBj: '0px'
            }
          }
        },
        {
          name: '图文导航',
          icon: 'font-icon font-icon-16',
          type: 14,
          preview: imgTextPreview,
          setting: {
            title: '图文设置',
            component: imgTextSetting
          },
          data: {
            name: '图文导航',
            title: '图文',
            imgTextList: [
              {
                src: 'http://www-x-it98-x-net.img.addlink.cn/data/upload/image/20160802/1470106441137082.jpg',
                name: '营销推广',
                link: '图文导航'
              },
              {
                src: 'http://www-x-it98-x-net.img.addlink.cn/data/upload/image/20160802/1470106461589105.jpg',
                name: '手机建站',
                link: '图文导航'
              },
              {
                src: 'http://www-x-it98-x-net.img.addlink.cn/data/upload/image/20160802/1470106455122950.jpg',
                name: '抢占排名',
                link: '图文导航'
              }
            ],
            linkList: [
              {
                title: '首页',
                page: 'index'
              },
              {
                title: '产品',
                page: 'product'
              },
              {
                title: '留言',
                page: 'message'
              },
              {
                title: '案例',
                page: 'case'
              },
              {
                title: '新闻',
                page: 'news'
              },
              {
                title: '联系',
                page: 'contact'
              }
            ],
            infoItme: {
              bjColor: '#ffffff',
              yeBj: '15px',
              sBj: '15px',
              xBj: '15px'
            },
            conStyle: {
              tupianjg: '默认',
              space: 10,
              titleSize: '12',
              titleColor: '#000000'
            }
          }
        },
        {
          name: '标题',
          icon: 'font-icon font-icon-11',
          type: 9,
          preview: TitlePreview,
          setting: {
            title: '标题栏设置',
            component: TitleSetting
          },
          data: {
            name: '标题',
            title: '成功案例',
            infoItme: {
              bjColor: '#eff2f7',
              yeBj: '15px',
              sBj: '15px',
              xBj: '15px'
            },
            conStyle: {
              titleColor: '#000000',
              titleSize: '16',
              titleBold: '是',
              titleAlign: '居中',
              moreType: '无',
              moreText: '查看更多',
              moreColor: '#000000',
              moreImg: '',
              moreLink: '首页'
            },
            link: '请选择标题链接',
            linkList: [
              {
                title: '首页',
                page: 'index'
              },
              {
                title: '产品',
                page: 'product'
              },
              {
                title: '留言',
                page: 'message'
              },
              {
                title: '案例',
                page: 'case'
              },
              {
                title: '新闻',
                page: 'news'
              },
              {
                title: '联系',
                page: 'contact'
              }
            ]
          }
        },
        {
          name: '产品列表',
          icon: 'font-icon font-icon-18',
          type: 16,
          preview: articleView,
          setting: {
            title: '产品列表',
            component: articleSetting
          },
          data: {
            name: '产品列表',
            title: '产品列表',
            neiRadio: '2',
            biliRadio: '1:1',
            bianjiaoRadio: '直角',
            boldRadio: '无',
            duiqiRadio: '居中',
            conValue: '3',
            consetting: {
              laiYvalue: '1',
              shuRadio: '1',

              fenleiValue: '',
              restaurants: [],
              num: 4
            },
            productList: [
              {
                src: 'http://www-x-it98-x-net.img.addlink.cn/data/images/case/thumb_20201119171846_423.jpg',
                name: '石家庄文义印刷有限公司'
              },
              {
                src: 'http://www-x-it98-x-net.img.addlink.cn/data/images/case/thumb_20201119164935_614.jpg',
                name: '河北鸿邦电气设备科技有限公司'
              },
              {
                src: 'http://www-x-it98-x-net.img.addlink.cn/data/images/case/thumb_20201119162623_277.jpg',
                name: '石家庄华普管道设备科技有限公司'
              },
              {
                src: 'http://www-x-it98-x-net.img.addlink.cn/data/images/case/thumb_20200723170850_416.jpg',
                name: '河北远澜建筑工程有限公司'
              }
            ],
            infoItme: {
              bjColor: '#ffffff',
              yeBj: '15px',
              sBj: '15px',
              xBj: '15px'
            }
          }
        },
        {
          name: '标题',
          icon: 'font-icon font-icon-11',
          type: 9,
          preview: TitlePreview,
          setting: {
            title: '标题栏设置',
            component: TitleSetting
          },
          data: {
            name: '标题',
            title: '网站资讯',
            infoItme: {
              bjColor: '#eff2f7',
              yeBj: '15px',
              sBj: '15px',
              xBj: '15px'
            },
            conStyle: {
              titleColor: '#000000',
              titleSize: '16',
              titleBold: '是',
              titleAlign: '居中',
              moreType: '无',
              moreText: '查看更多',
              moreColor: '#000000',
              moreImg: '',
              moreLink: '首页'
            },
            link: '请选择标题链接',
            linkList: [
              {
                title: '首页',
                page: 'index'
              },
              {
                title: '产品',
                page: 'product'
              },
              {
                title: '留言',
                page: 'message'
              },
              {
                title: '案例',
                page: 'case'
              },
              {
                title: '新闻',
                page: 'news'
              },
              {
                title: '联系',
                page: 'contact'
              }
            ]
          }
        },
        {
          name: '文章列表',
          icon: 'font-icon font-icon-19',
          type: 17,
          preview: wenzView,
          setting: {
            title: '文章列表',
            component: wenzSetting
          },
          data: {
            name: '文章列表',
            title: '文章列表',
            neiRadio: '1',
            biliRadio: '1:1',
            bianjiaoRadio: '直角',
            boldRadio: '无',
            conValue: '3',
            productList: [
              {
                src: '',
                name: '如何提升外贸网站的搜索排名？'
              },
              {
                src: '',
                name: '外贸网站优化策略的实用指导'
              },
              {
                src: '',
                name: '电子商务网站建设打造成功的在线商店'
              },
              {
                src: '',
                name: '网站设计趋势2024如何保持你的网站现代...'
              }
            ],
            infoItme: {
              bjColor: '#ffffff',
              yeBj: '15px',
              sBj: '15px',
              xBj: '15px'
            }
          }
        },
        {
          name: '企业简介',
          icon: 'font-icon font-icon-1',
          type: 1,
          preview: CompanyInfoPreview,
          setting: {
            title: '企业简介',
            component: CompanyInfoSetting
          },
          data: {
            name: '企业简介',
            title: '企业简介',
            content: `
            河北墨点云网络科技有限公司方秉承"诚信为本、长期服务"的宗旨，将以务实创新的精神， 与国内外企业携手并进，为推进企业的信息化进程而全力以赴！ 　　

主营网站建设、外贸网站建设、推广优化、商城、微分销、微网站、摇动中国、ui设计、app开发、高端网站设计、高端网站制作、PC网站制作、IOS、公众号、小程序商城等互联网基础应用运营服务。
            `
          }
        },
        {
          name: '图片',
          icon: 'font-icon font-icon-13',
          type: 11,
          preview: ImagePreview,
          setting: {
            title: '图片设置',
            component: ImageSetting
          },
          data: {
            name: '图片',
            imageType: 1,
            images:
              'http://www-x-it98-x-net.img.addlink.cn/data/upload/image/20190725/1564050128331820.jpg',
            link: '图片导航链接',
            linkList: [
              {
                title: '首页',
                page: 'index'
              },
              {
                title: '产品',
                page: 'product'
              },
              {
                title: '留言',
                page: 'message'
              },
              {
                title: '案例',
                page: 'case'
              },
              {
                title: '新闻',
                page: 'news'
              },
              {
                title: '联系',
                page: 'contact'
              }
            ]
          }
        },
        {
          name: '文本',
          icon: 'font-icon font-icon-12',
          type: 10,
          title: '文本',
          preview: TextPreview,
          setting: {
            title: '文本设置',
            component: TextSetting
          },
          data: {
            name: '文本',
            text: `
            联系方式：


大客户专线：4001819185

公司网址：www.it98.net

公司地址：河北省石家庄市长安区建设北大街富邦大厦六楼
            `
          }
        },
        {
          name: '地址',
          icon: 'font-icon font-icon-6',
          type: 7,
          preview: AddressPreview,
          setting: {
            title: '公司地址',
            component: AddressSetting
          },
          data: {
            name: '地址',
            title: '富邦大厦-西门',
            addressDetail: '富邦大厦',
            items: {
              id: '7600048542285331526',
              title: '富邦大厦-西门',
              address: '河北省石家庄市长安区建设北大街',
              category: '室内及附属设施:通行设施类:门/出入口',
              type: 0,
              location: {
                lat: 38.0451,
                lng: 114.512096
              },
              adcode: 130102,
              province: '河北省',
              city: '石家庄市',
              district: '长安区'
            }
          }
        },
        {
          name: '标题',
          icon: 'font-icon font-icon-11',
          type: 9,
          preview: TitlePreview,
          setting: {
            title: '标题栏设置',
            component: TitleSetting
          },
          data: {
            name: '标题',
            title: '欢迎给我们留言',
            infoItme: {
              bjColor: '#E40202',
              yeBj: '15px',
              sBj: '15px',
              xBj: '15px'
            },
            conStyle: {
              titleColor: '#ffffff',
              titleSize: '16',
              titleBold: '是',
              titleAlign: '居中',
              moreType: '无',
              moreText: '查看更多',
              moreColor: '#000000',
              moreImg: '',
              moreLink: '首页'
            },
            link: '请选择标题链接',
            linkList: [
              {
                title: '首页',
                page: 'index'
              },
              {
                title: '产品',
                page: 'product'
              },
              {
                title: '留言',
                page: 'message'
              },
              {
                title: '案例',
                page: 'case'
              },
              {
                title: '新闻',
                page: 'news'
              },
              {
                title: '联系',
                page: 'contact'
              }
            ]
          }
        },
        {
          name: '表单',
          icon: 'font-icon font-icon-20',
          type: 18,
          preview: formView,
          setting: {
            title: '表单',
            component: formSetting
          },
          data: {
            name: '表单',
            form: {
              titleValue: true,
              inputStyle: '描边',
              mbColor: '#D9DCE2',
              tcColor: '#ffffff',
              btnColor: '#409EFF',
              name: {
                title: '姓名',
                tipTxt: '提示文字',
                errTxt: '请输入姓名'
              },
              phone: {
                title: '电话',
                tipTxt: '提示文字',
                errTxt: '请输入手机号',
                yzErr: '请输入正确手机号'
              },
              content: [
                {
                  type: '1',
                  title: '内容',
                  tipTxt: '请输入您的留言内容',
                  visible: false,
                  errTxt: '此项必填',
                  radioVal: 1,
                  selectVal: '',
                  checkboxGroup: [],
                  emailErr: '邮箱格式不正确',
                  groups: [
                    {
                      text: '选项一',
                      value: 1,
                      checkd: false
                    },
                    {
                      text: '选项二',
                      value: 2,
                      checkd: false
                    },
                    {
                      text: '选项三',
                      value: 3,
                      checkd: false
                    }
                  ],
                  radioMap: [
                    {
                      text: '选项一',
                      value: 1,
                      checkd: false
                    },
                    {
                      text: '选项二',
                      value: 2,
                      checkd: false
                    },
                    {
                      text: '选项三',
                      value: 3,
                      checkd: false
                    }
                  ],
                  selectOptions: [
                    {
                      value: 1,
                      text: '选项一',
                      checkd: false
                    },
                    {
                      value: 2,
                      text: '选项二',
                      checkd: false
                    },
                    {
                      value: 3,
                      text: '选项三',
                      checkd: false
                    }
                  ]
                }
              ],
              btnName: '提交'
            },
            infoItme: {
              bjColor: '#ffffff',
              yeBj: '15px',
              sBj: '15px',
              xBj: '15px'
            }
          }
        },
        {
          name: '合作伙伴',
          icon: 'font-icon font-icon-4',
          type: 5,
          preview: CompanyPartnerPreview,
          setting: {
            title: '合作伙伴',
            component: CompanyPartnerSetting
          },
          data: {
            name: '合作伙伴',
            title: '合作伙伴',
            imageList: [
              {
                src: ''
              },
              {
                src: ''
              },
              {
                src: ''
              }
            ]
          }
        }
      ],
      // 设置项
      editing: null
    }
  },
  computed: {
    style: function () {
      return {
        componentTabs: {
          float: 'left',
          width: '300px',
          height: '100%',
          overflow: 'hidden'
        },
        phoneBox: {
          float: 'left',
          width: this.screenWidth - 820 + 'px',
          height: '100%'
        },
        settingBox: {
          // float: 'right',
          // width: '500px',
          height: '100%',
          overflow: 'auto'
        }
      }
    }
  },
  methods: {
    handledrag: function (item) {
      this.drag = item
    },
    handleTabClick: async function (component, newIndex) {
      console.log('走进来了吗', component, newIndex)
      let designData = {
        type: component.type,
        preview: component.preview,
        setting: component.setting,
        visible: false,
        name: component.name || '',
        typeName: component.typeName || '',
        data: {
          type: component.type,
          // 深度复制
          ...JSON.parse(JSON.stringify(component.data))
        }
      }
      if (component.typeName === 'modules') {
        if (component.name === '联系') {
          this.designs = []
          this.designs.push({
            name: '联系',
            icon: 'font-icon font-icon-12',
            type: 10,
            title: '联系',
            preview: TextPreview,
            typeName: 'modules',
            setting: {
              title: '文本设置',
              component: TextSetting
            },
            data: {
              name: '联系',
              text: `
                联系我们\n
                联系人：吴总\n
                联系电话：400-007-8608\n
                公司地址：河北石家庄富邦大厦665室
                `
            }
          })

          this.editing = this.designs[0]

          return
        }
        if (component.name === '关于') {
          this.designs = []
          this.designs.push(
            {
              name: '联系',
              icon: 'font-icon font-icon-12',
              type: 10,
              title: '联系',
              preview: TextPreview,
              typeName: 'modules',
              setting: {
                title: '文本设置',
                component: TextSetting
              },
              data: {
                name: '联系',
                text: `
                联系我们\n
                联系人：吴总\n
                联系电话：400-007-8608\n
                公司地址：河北石家庄富邦大厦665室
                `
              }
            },
            {
              name: '图片',
              icon: 'font-icon font-icon-13',
              type: 11,
              preview: ImagePreview,
              setting: {
                title: '图片设置',
                component: ImageSetting
              },
              data: {
                name: '图片',
                imageType: 1,
                images: '',
                link: '图片导航链接',
                linkList: [
                  {
                    title: '首页',
                    page: 'index'
                  },
                  {
                    title: '产品',
                    page: 'product'
                  },
                  {
                    title: '留言',
                    page: 'message'
                  },
                  {
                    title: '案例',
                    page: 'case'
                  },
                  {
                    title: '新闻',
                    page: 'news'
                  },
                  {
                    title: '联系',
                    page: 'contact'
                  }
                ]
              }
            },
            {
              name: '联系',
              icon: 'font-icon font-icon-12',
              type: 10,
              title: '联系',
              preview: TextPreview,
              typeName: 'modules',
              setting: {
                title: '文本设置',
                component: TextSetting
              },
              data: {
                name: '联系',
                text: `
                联系我们\n
                联系人：吴总\n
                联系电话：400-007-8608\n
                公司地址：河北石家庄富邦大厦665室
                `
              }
            }
          )

          this.designs.map((item, index) => {
            this.editing = this.designs[index]
            console.log('赋值动作', this.editing)
          })

          return
        }
        if (component.name === '首页') {
          // this.designs = this.designs
          this.editing = null
          this.getAllList()
          return
        }
        switch (component.name) {
          case '在线留言':
            const res = await this.getAll()
            if (res.message) {
              // this.components.modules
              designData.data = res.message[0]
              this.designs = [designData]
              console.log('在线留言数据', designData, this.designs)
            }
            if (res.footer) {
              this.components.footer.data = res.footer.data

              console.log('底部导航数据', this.components.footer)
            }
            break
          case '产品':
            const res1 = await this.getAll()
            if (res1.product) {
              // this.components.modules
              designData.data = res1.product[0]
              this.designs = [designData]
              console.log('产品数据', designData, this.designs)
            }
            if (res1.footer) {
              this.components.footer.data = res1.footer.data

              console.log('底部导航数据', this.components.footer)
            }
            break
          case '产品详情':
            const res2 = await this.getAll()
            if (res2.productDetails) {
              // this.components.modules
              designData.data = res2.productDetails[0]
              this.designs = [designData]
              console.log('产品数据', designData, this.designs)
            }
            if (res2.footer) {
              this.components.footer.data = res2.footer.data

              console.log('底部导航数据', this.components.footer)
            }
            break
          case '列表':
            const res3 = await this.getAll()
            if (res3.list) {
              // this.components.modules
              designData.data = res3.list[0]
              this.designs = [designData]
              console.log('产品数据', designData, this.designs)
            }
            if (res3.footer) {
              this.components.footer.data = res3.footer.data

              console.log('底部导航数据', this.components.footer)
            }
            break
          case '详情':
            const res4 = await this.getAll()
            if (res4.CaseDetails) {
              // this.components.modules
              designData.data = res4.CaseDetails[0]
              this.designs = [designData]
              console.log('产品数据', designData, this.designs)
            }
            if (res4.footer) {
              this.components.footer.data = res4.footer.data

              console.log('底部导航数据', this.components.footer)
            }
            break
          case '联系':
            const res5 = await this.getAll()
            if (res5.contact) {
              // this.components.modules
              designData.data = res5.contact[0]
              this.designs = [designData]
              console.log('产品数据', designData, this.designs)
            }
            if (res5.footer) {
              this.components.footer.data = res5.footer.data

              console.log('底部导航数据', this.components.footer)
            }
            break
          default:
            break
        }
        this.designs = [designData]
        this.editing = designData
        console.log('也走这里了', this.designs)
      } else {
        if (this.designs.length > 0 && this.designs[0].typeName) {
          this.designs = []
        }
        if (newIndex !== undefined) {
          this.designs.splice(newIndex, 0, designData)
          console.log('是否有newIndex', newIndex, designData, this.designs)
        } else {
          this.designs.push(designData)
        }
      }
      this.editing = designData
    },
    getAll: async function () {
      try {
        const response = await api.post('/applet/get_all_data')

        if (response.code === 0) {
          return response.data
        }
      } catch (error) {
        console.error('Error sending data:', error)
      }
    },
    handleUploadArr: function (items) {
      this.designs = []
      this.designs = items
    },
    handleDesignClick: function (designData) {
      this.editing = designData
      console.log('是这个吗', this.editing)
    },
    handleSaveClick: function () {
      console.log(this.designs.map(({ data }) => ({ ...data })))
      console.log(this.components.footer)
    },
    handleConfirmClick: async function () {
      console.log('点击保存22222', this.designs.map(({ data }) => ({ ...data })))
      console.log(this.components.footer)
      const des = this.designs.map(({ data }) => ({ ...data }))
      let type = ''
      console.log('要保存的数据', des, des[0].name)
      switch (des[0].name) {
        case '在线留言':
          type = 'message'
          break
        case '产品':
          type = 'product'
          break
        case '产品详情':
          type = 'productDetails'
          break
        case '列表':
          type = 'list'
          break
        case '详情':
          type = 'CaseDetails'
          break
        case '联系':
          type = 'contact'
          break
        case '关于':
          type = 'about'
          break
        default:
          type = 'index'
      }
      try {
        const data = { type: type, all: des, muban_id: '1' } // 需要发送的请求数据
        const response = await api.post('/applet/sub_all_data', data)
        const footerData = { type: 'footer', all: this.components.footer, muban_id: '1' }
        if (response) {
          await api.post('/applet/sub_all_data', footerData)
        }
        if (response.code === 0) {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.getAllList()
        }
        console.log('保存所有数据:', response, footerData)
      } catch (error) {
        console.error('Error sending data:', error)
      }
    },
    handleDeleteItem: function (item) {
      if (item) {
        this.editing = null
      }
    },
    // 页面基础数据
    async getAllList () {
      try {
        const response = await api.post('/applet/get_all_data')
        console.log('请求所有数据:', response.data.index, this.components.basics)
        if (response.code === 0) {
          if (response.data.index) {
            // this.designs = response.data.index
            this.designs = this.newArr(this.components.basics, response.data.index)
          }
          if (response.data.footer) {
            this.components.footer.data = response.data.footer.data

            console.log('底部导航数据', this.components.footer)
          }
        }
      } catch (error) {
        console.error('Error sending data:', error)
      }
    },
    newArr (oldVal, newVal) {
      // 创建一个基础组件的映射表,用name作为key
      const basicsMap = oldVal.reduce((map, item) => {
        map[item.data.name] = item
        return map
      }, {})
      // 根据服务器返回数据生成新的组件数组
      const newDesigns = newVal.map(serverItem => {
        const localItem = basicsMap[serverItem.name]
        if (localItem) {
          // 创建新的组件对象，保留原有结构
          const newComponent = {
            ...localItem,
            // data部分进行深拷贝并合并
            data: {
              ...JSON.parse(JSON.stringify(localItem.data)),
              ...serverItem
            }
          }
          return newComponent
        }
        return null
      }).filter(item => item !== null) // 过滤掉未匹配的项

      return newDesigns
    }
  },

  mounted: function () {
    const onResize = () => {
      this.screenHeight = document.body.clientHeight - 60
      this.screenWidth = document.body.clientWidth
    }
    onResize()
    window.addEventListener('resize', onResize, false)

    this.getAllList()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/ColEditWindow.vue